import { Component, Input } from '@angular/core';
import { RegionType } from '../../../location/region-type.enum';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  standalone: false,
  selector: 'mtn-region-field',
  templateUrl: './region-field.component.html',
  styleUrls: ['./region-field.component.scss']
})
export class RegionFieldComponent {

  @Input()
  form: UntypedFormGroup;
  @Input()
  controlName: string = 'region';
  @Input()
  isMarketAreaAvailable = true;
  @Input()
  placeholder: string = 'Region';

  RegionType = RegionType;

  constructor() {
  }

}
